// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1hZd-","messages":"Chat_messages__K3zkY","dateDivider":"Chat_dateDivider__1KI6F"};